import Request from '../../utils/request';
export const baseURL = 'https://cruuunchify-share.web.app';

export const explore = new Request('/explore', baseURL);
